import corptaxLogo from '../../images/csc_horizontal_RGB_white.svg';

export interface ICorptaxHomeLogoLinkProps {
    logoHref: string;
}

export const CorptaxHomeLogoLink = (props: ICorptaxHomeLogoLinkProps) => {
    return (
        <a href={props.logoHref} aria-label="Corptax Home">
            <img src={corptaxLogo} alt="Corptax Home Logo" width={100} height={25} />
        </a>
    );
};
